module.exports = __webpack_public_path__ + "img/table-green.26911091.svg";